import type { ResumeBenchmarkDetailResponse } from "@/_models/resume-benchmark";
import type { AnalysisResult } from "../mockdata/analysisData";

function getImprovementPriority(index: number): "high" | "medium" | "low" {
  if (index < 2) return "high";
  if (index < 4) return "medium";
  return "low";
}

export function mapBenchmarkDetailsToAnalysisResult(
  response: ResumeBenchmarkDetailResponse,
): AnalysisResult {
  const { resume } = response;
  const { benchmark_result: benchmark, details, summary } = resume;
  const basicInfo = details.basic_info;

  const strengths = benchmark.strength_feedback.map((item) => ({
    title: item.title,
    description: item.detail,
  }));

  const weaknesses = benchmark.improvement_feedback.map((item) => ({
    title: item.title,
    description: item.detail,
  }));

  const improvements = benchmark.how_to_improve.map((item, index) => ({
    section: item.title,
    suggestion: item.detail,
    priority: getImprovementPriority(index),
  }));

  return {
    candidateName: resume.resume_name || basicInfo.name,
    candidateEmail: resume.resume_email || basicInfo.email,
    candidateTitle: basicInfo.job_title ?? "",
    scorecards: {
      overall: benchmark.overall_score,
      experiences: benchmark.experience_score,
      skills: benchmark.skills_score,
      language: benchmark.language_score,
      education: benchmark.education_score,
      certificates: benchmark.certificate_score,
    },
    aiSummary: summary,
    radarData: [
      { category: "Experience", value: benchmark.experience_score },
      { category: "Skills", value: benchmark.skills_score },
      { category: "Language", value: benchmark.language_score },
      { category: "Certificates", value: benchmark.certificate_score },
      { category: "Education", value: benchmark.education_score },
      { category: "ATS", value: benchmark.ats_proper_score },
    ],
    strengths,
    weaknesses,
    improvements,
    atsScore: benchmark.ats_proper_score,
    atsIssues: benchmark.improvement_feedback.map(
      (item) => `${item.title}: ${item.detail}`,
    ),
  };
}
